// import { registerAction } from "./Module/actions";
import NumberTextField from "components/LabelInput/NumberTextField";
import SubTitle from "components/PageTitle/SubTitle";

const SubscribeItem = ({ restData }) => {
  const textBoxWidth = "10rem";
  const textLabelWidth = "6rem";
  const labelMarginLeft = "2.625rem";
  return (
    <div style={{}}>
      <SubTitle titleText={"구독형 회원권 정가"} />
      <div style={{ marginLeft: "2rem" }}>
        <div
          style={{
            display: "flex",
            marginTop: "0.625rem",
          }}
        >
          <NumberTextField
            isNumber
            labelWidth={textLabelWidth}
            textBoxWidth={textBoxWidth}
            labelText="· 등록 수수료"
            endAdornment="원"
            minValue={0}
            maxValue={99999999}
            defaultValue={restData.base_policy.subs_reg}
            onChangeCallback={(e) => {
              restData.base_policy.subs_reg = e;
            }}
          />

          <NumberTextField
            isNumber
            labelWidth={textLabelWidth}
            textBoxWidth={textBoxWidth}
            labelMarginLeft={labelMarginLeft}
            labelText="· 회원권 1개월"
            endAdornment="원"
            minValue={0}
            maxValue={99999999}
            defaultValue={restData.base_policy.subs_mbshp}
            onChangeCallback={(e) => {
              restData.base_policy.subs_mbshp = e;
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "0.625rem",
          }}
        >
          <NumberTextField
            isNumber
            labelWidth={textLabelWidth}
            textBoxWidth={textBoxWidth}
            labelText="· 운동복 1개월"
            endAdornment="원"
            minValue={0}
            maxValue={99999999}
            defaultValue={restData.base_policy.subs_cloth}
            onChangeCallback={(e) => {
              restData.base_policy.subs_cloth = e;
            }}
          />

          <NumberTextField
            isNumber
            labelWidth={textLabelWidth}
            textBoxWidth={textBoxWidth}
            labelMarginLeft={labelMarginLeft}
            labelText="· 락커 1개월"
            endAdornment="원"
            minValue={0}
            maxValue={99999999}
            defaultValue={restData.base_policy.subs_locker}
            onChangeCallback={(e) => {
              restData.base_policy.subs_locker = e;
            }}
          />

          <NumberTextField
            isNumber
            labelWidth={textLabelWidth}
            textBoxWidth={textBoxWidth}
            labelMarginLeft={labelMarginLeft}
            labelText="· GX 1개월"
            endAdornment="원"
            minValue={0}
            maxValue={99999999}
            defaultValue={restData.base_policy.subs_gx}
            onChangeCallback={(e) => {
              restData.base_policy.subs_gx = e;
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default SubscribeItem;
